import React, { useRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

// 导入公共资产
// import brush from '../../sources/Graph/Brush_purple.png';
/*
import aboutUs_1 from '../../sources/Graph/AboutUs_1.png';
import aboutUs_2 from '../../sources/Graph/AboutUs_2.png';
import aboutUs_3 from '../../sources/Graph/AboutUs_3.png';
import aboutUs_4 from '../../sources/Graph/AboutUs_4.png';
*/

// 滚动动效组件 (Scroll Reveal Helper)
const RevealOnScroll = ({ children, delay = 0 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.18,
                rootMargin: "0px 0px -8% 0px"
            }
        );
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []);

    return (
        <Box
            ref={ref}
            sx={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateY(0)" : "translateY(24px)",
                transition: `opacity 700ms ease-out ${delay}s, transform 700ms ease-out ${delay}s`,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                willChange: 'opacity, transform',
                '@media (prefers-reduced-motion: reduce)': {
                    opacity: 1,
                    transform: 'none',
                    transition: 'none',
                },
            }}
        >
            {children}
        </Box>
    );
};

export default function AboutUs() {
    const { t } = useTranslation();

    const textStyle = {
        fontFamily: "Noto Sans TC",
        color: "#4E433C",
        fontSize: { xs: 17, md: 24 },
        fontWeight: 400,
        lineHeight: { xs: 1.7, md: 1.75 },
        textAlign: "left",
        margin: 0,
    };

    const narrativeStyle = {
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        textAlign: "left",
    };

    return (
        <Box
            component="section"
            aria-labelledby="about-us-title"
            width={"100%"}
            sx={{ py: { xs: 4, md: 6 }, overflow: 'hidden' }}
        >
            {/* 顶部的标题 */}
            <Typography
                id="about-us-title"
                component="h2"
                fontFamily={"Noto Sans TC"}
                textAlign={"center"}
                fontSize={{ xs: "28px", md: "42px" }}
                fontWeight={700}
                fontStyle={"normal"}
                color='#7DC4A2'
                py={3}
                mb={{ xs: 4, md: 6 }}
                sx={{
                    textShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
                    lineHeight: '100%',
                    position: 'relative'
                    // backgroundImage: `url(${brush})`,
                    // backgroundSize: 'contain',
                    // backgroundPosition: 'center',
                    // backgroundRepeat: 'no-repeat',
                    // backgroundPositionY: { xs: 35, md: 55 }
                }}
            >
                {t('AboutUs.title')}
            </Typography>

            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1040px",
                    margin: "0 auto",
                    px: { xs: 3, md: 5 },
                    pb: { xs: 3, md: 5 },
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 5, md: 8 },
                }}
            >
                <RevealOnScroll>
                    <Box component="article" sx={narrativeStyle}>
                        <Typography component="h3" sx={{ ...textStyle, fontWeight: 700 }}>
                            {t('AboutUs.statement')}
                        </Typography>
                    </Box>
                </RevealOnScroll>

                <RevealOnScroll delay={0.05}>
                    <Box component="article" sx={narrativeStyle}>
                        <Typography sx={textStyle}>
                            {t('AboutUs.paragraph1')}
                        </Typography>
                    </Box>
                </RevealOnScroll>

                <RevealOnScroll delay={0.1}>
                    <Box component="article" sx={narrativeStyle}>
                        <Typography sx={textStyle}>
                            {t('AboutUs.paragraph2')}
                        </Typography>
                    </Box>
                </RevealOnScroll>
            </Box>
        </Box>
    );
}
